import React from 'react';
import './Navbar.css'; 

function Navbar() {
  return (
    <div className="navbar">
      <div className="logo-text">Lakss Recycling Limited</div>
      <ul className="nav-links">
        <li><a href="#">Home</a></li>
        <li><a href="#">About Us</a></li>
        <li><a href="#">Products</a></li>
        <li><a href="#">Contact</a></li>
      </ul>
      <div className="search-box">
        <input type="text" placeholder="Search..." />
        <button>Search</button>
      </div>
      <div className="buttons">
        <button className="login">Client Login</button>
        <button className="signup">Client Sign Up</button>
      </div>
    </div>
  );
}

export default Navbar;
